// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

// MEGAMENU **********************************************************************************
/*********************************************************************************************
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = "none"));
	document.querySelector(classElemToShow).style.display = "grid";
};

/*********************************************************************************************
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector("[data-mm-header]");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll("[data-megamenulink]").forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute("data-megamenu")) {
			megaMenu.style.top = `${headerHeight}px`;
		}
	});
};

/*********************************************************************************************
 * Open / close the mega menus with a delay, so the cursor can travel from the link
 * to the mega menu (even diagonally, over other links) without closing it.
 *
 */
const mmInitMegaMenuHover = () => {
	const CLOSE_DELAY = 300;
	const SWITCH_DELAY = 150;
	let openItem = null;
	let closeTimer = null;
	let switchTimer = null;

	const clearTimers = () => {
		clearTimeout(closeTimer);
		clearTimeout(switchTimer);
	};

	const close = () => {
		if (!openItem) return;
		openItem.wrapper.classList.remove("mm-open");
		openItem.link.setAttribute("aria-expanded", "false");
		openItem = null;
	};

	const open = (item) => {
		if (openItem === item) return;
		close();
		item.wrapper.classList.add("mm-open");
		item.link.setAttribute("aria-expanded", "true");
		openItem = item;
	};

	const scheduleClose = () => {
		clearTimers();
		closeTimer = setTimeout(close, CLOSE_DELAY);
	};

	document.querySelectorAll("[data-megamenulink]").forEach((link) => {
		const wrapper = link.nextElementSibling;
		if (!wrapper?.hasAttribute("data-megamenu")) return;
		const item = { link, wrapper };

		link.addEventListener("mouseenter", () => {
			clearTimers();
			// Un autre mega menu est ouvert : on attend un peu avant de basculer
			// pour ne pas changer de menu quand on ne fait que traverser le lien.
			if (openItem && openItem !== item) {
				switchTimer = setTimeout(() => open(item), SWITCH_DELAY);
			} else {
				open(item);
			}
		});
		link.addEventListener("mouseleave", scheduleClose);
		wrapper.addEventListener("mouseenter", () => {
			if (openItem === item) clearTimers();
		});
		wrapper.addEventListener("mouseleave", scheduleClose);
	});

	// Les liens sans mega menu ferment le mega menu ouvert (avec le même délai de traversée)
	document.querySelectorAll("[data-menulink]").forEach((link) => {
		link.addEventListener("mouseenter", () => {
			if (!openItem) return;
			clearTimers();
			switchTimer = setTimeout(close, SWITCH_DELAY);
		});
	});
};

// BACKGROUND FILTER *************************************************************************
/*********************************************************************************************
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector("[data-mm-header]");
	const searchContainer = document.querySelector("[data-search-container]");
	const megaMenuLinks = document.querySelectorAll("[data-megamenulink]");
	const menuLinks = document.querySelectorAll("[data-menulink]");
	const filter = document.querySelector("[data-filter]");
	const cart = document.querySelector("[data-cart-filter]");

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle("active", show);
	};

	megaMenuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(true)));
	menuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(false)));

	header.addEventListener("mouseleave", () => {
		if ((!searchContainer || !searchContainer.classList.contains("mm-open")) && !cart.classList.contains("mm-dc-is-open")) {
			toggleFilter(false);
		}
	});
};

/*********************************************************************************************
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	filter.classList.add("active");
	if (zIndex) filter.style.zIndex = zIndex;
};

/*********************************************************************************************
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/*********************************************************************************************
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
    document.querySelectorAll("a:not(.consent-wrapper):not(.mm-header-account-container):not(.mm-footer-menu-sub-link--axeptio)").forEach((link) => {
        if (link.hostname !== window.location.hostname) {
            link.target = "_blank";
            link.rel = "noreferrer noopener";
        }
    });
};

// MENU MOBILE *******************************************************************************
/*********************************************************************************************
 * Toggle the mobile menu.
 *
 */
const mmMobileMenu = () => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		headerMenu: document.querySelector("[data-mm-header]"),
		html: document.documentElement,
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, headerMenu, html } = elements;

	// const headerHeight = headerMenu.offsetHeight;
	// const headerMenuTop = headerMenu.getBoundingClientRect().top;
	const topPosition = `0px`;
	const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

	[header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
	html.classList.add("stop-scrolling");

	Object.assign(mobileMenu.style, { top: topPosition, height: heightCalc });

	showBgFilter("var(--index-lg)");
};

/*********************************************************************************************
 * Close the mobile menu.
 *
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
	if (window.innerWidth > 990) return;

	const elements = {
		header: document.querySelector("header"),
		icon: document.querySelector("[data-header-burger]"),
		mobileMenu: document.querySelector("[data-menu-mobile]"),
		html: document.querySelector("html"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { header, icon, mobileMenu, html } = elements;

	[header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
	html.classList.remove("stop-scrolling");

	if (!keepFilterActive) hideBgFilter();
};

/*********************************************************************************************
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowNext = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.add("mm-mobile-menu-elem-slided");
};

/*********************************************************************************************
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	document.querySelector(elemToShowClass)?.classList.remove("mm-mobile-menu-elem-slided");
};

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	// Empêcher la double initialisation si la fonction est rappelée après un rerender
	dropWrappers.forEach((item) => {
		if (item.dataset.dropdownInitialized === "true") return;
		item.dataset.dropdownInitialized = "true";

		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove("active");
					el.setAttribute("aria-expanded", "false");
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				const isActive = this.classList.contains("active");
				this.setAttribute("aria-expanded", isActive ? "true" : "false");
				content.style.maxHeight = isActive ? `${content.scrollHeight}px` : null;
			}
		});
	});
};

/**
 * Handle dropdown behavior allowing multiple dropdowns to be open simultaneously.
 * This version does NOT close other dropdowns when opening a new one.
 *
 */
const handleDropdownMultiple = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown-multiple"]');

	// Empêcher la double initialisation si la fonction est rappelée après un rerender
	dropWrappers.forEach((item) => {
		if (item.dataset.dropdownMultipleInitialized === "true") return;
		item.dataset.dropdownMultipleInitialized = "true";

		item.addEventListener("click", function () {
			// Pas de fermeture des autres dropdowns - chaque dropdown fonctionne indépendamment
			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				const isActive = this.classList.contains("active");
				this.setAttribute("aria-expanded", isActive ? "true" : "false");
				content.style.maxHeight = isActive ? `${content.scrollHeight}px` : null;
			}
		});
	});
};

// Exposer les fonctions globalement pour qu'elles puissent être appelées après le refresh du panier
window.handleDropdown = handleDropdown;
window.handleDropdownMultiple = handleDropdownMultiple;

// SEARCH ************************************************************************************
/*********************************************************************************************
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;

	html.classList.add("stop-scrolling");
	search.classList.add("mm-open");
	showBgFilter();

	setTimeout(() => searchInput.focus(), 1000);

	document.getElementById("predictive-search")?.addEventListener("touchstart", () => {
		setTimeout(() => searchInput.blur(), 500);
	});
};

/*********************************************************************************************
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false, keepStopScrolling = false) => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.getElementById("Search"),
	};

	if (Object.values(elements).some((el) => !el)) return;

	const { search, html, searchInput } = elements;
	if (!keepStopScrolling) {
		html.classList.remove("stop-scrolling");
	}
	search.classList.remove("mm-open");
	if (!keepFilterActive) hideBgFilter();

	searchInput.value = "";
	searchInput.dispatchEvent(new Event("input"));
};

/*********************************************************************************************
 * Initialize parallax effect for slide images.
 *
 */
const mmInitParallax = () => {
	const images = document.querySelectorAll(".mm-slide-image");
	if (!images.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const slideImage = entry.target;
					const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
					if (!covers.length) return;

					covers.forEach((cover) => {
						gsap.to(cover, {
							yPercent: 30,
							ease: "none",
							scrollTrigger: {
								trigger: slideImage,
								start: "top bottom",
								end: "bottom top",
								scrub: true,
							},
						});
					});

					observer.unobserve(slideImage);
				}
			});
		},
		{
			rootMargin: "0px 0px 200px 0px",
		}
	);

	images.forEach((image) => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
			const source = video.querySelector("source");
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

			video.load();
			video.play().catch((err) => console.warn("Auto-play failed:", err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = "false";
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

// READ MORE **********************************************************************************
/**
 * Handle read more behavior.
 *
 */
const mmReadMore = () => {
	const toggleButtons = document.querySelectorAll("[data-toggle]");

	toggleButtons.forEach(function (btn) {
		btn.addEventListener("click", function () {
			const container = btn.closest("[data-read-more-container]");
			const textElement = container.querySelector("[data-text]");
			const labelShow = btn.querySelector("[data-label-show]");
			const labelHide = btn.querySelector("[data-label-hide]");

			const expanded = btn.getAttribute("aria-expanded") === "true";

			if (!expanded) {
				textElement.classList.add("expanded");
				btn.setAttribute("aria-expanded", "true");
				labelShow.hidden = true;
				labelHide.hidden = false;
			} else {
				textElement.classList.remove("expanded");
				btn.setAttribute("aria-expanded", "false");
				labelShow.hidden = false;
				labelHide.hidden = true;
			}
		});
	});
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 *
 */
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

/*********************************************************************************************
 * Custom element for product recommendations
 *
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						// Réinitialiser la wishlist pour les nouvelles cartes de produits
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}
					} else {
						const parentElement = this.closest(".mm-section");
						if (parentElement) {
							parentElement.style.display = "none";
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

// PREVENT DOUBLE TAP ZOOM ****************************************************************
/*********************************************************************************************
 * Apply touch-action: manipulation to all interactive elements to prevent zoom on double tap
 *
 */
const preventDoubleTapZoom = () => {
	const interactiveElements = document.querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"]');
	interactiveElements.forEach(el => {
		el.style.touchAction = 'manipulation';
	});
};

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	preventDoubleTapZoom();
	getMegaMenuPosition();
	mmInitMegaMenuHover();
	hoverBgFilter();
	externalLink();
	handleDropdown();
	handleDropdownMultiple();
	documentHeight();
	mmInitParallax();
	mmInitVideoLazy();
	mmReadMore();
	
	// Init UI des product cards (soumission via formulaires)
	if (typeof window.mmInitProductCards === 'function') {
		window.mmInitProductCards();
	}
	


	// Information panel open/close handlers
	window.mmOpenPanelInformation = (productId) => {
		try {
			const panels = document.querySelectorAll(`[data-info-panel="${productId}"]`);
			if (!panels || panels.length === 0) return;

			// Privilégier un panneau déjà directement sous <body>, sinon prendre le premier
			let panel = Array.from(panels).find((p) => p.parentElement === document.body) || panels[0];

			// Échapper aux conteneurs avec transform/overflow (ex: Splide) en déplaçant le panneau sous <body>
			if (panel.parentElement !== document.body) {
				document.body.appendChild(panel);
			}

			// Étape 1 : rendre visible (display: flex)
			panel.classList.add('mm-visible');
			panel.setAttribute('aria-hidden', 'false');
			document.documentElement.classList.add('stop-scrolling');
			
			// Étape 2 : déclencher l'animation après le reflow
			requestAnimationFrame(() => {
				panel.classList.add('mm-open');
			});
		} catch (e) {
			console.error('mmOpenPanelInformation error', e);
		}
	};

	window.mmClosePanelInformation = () => {
		try {
			const openPanel = document.querySelector('.mm-info-panel.mm-open') || document.querySelector('[data-info-panel]:not([aria-hidden="true"])');
			if (!openPanel) return;
			
			// Retirer la classe d'animation
			openPanel.classList.remove('mm-open');
			openPanel.setAttribute('aria-hidden', 'true');
			document.documentElement.classList.remove('stop-scrolling');
			
			// Attendre la fin de la transition (0.5s) avant de cacher avec display: none
			setTimeout(() => {
				openPanel.classList.remove('mm-visible');
			}, 500);
		} catch (e) {
			console.error('mmClosePanelInformation error', e);
		}
	};
});

/*********************************************************************************************
 * Resized Listenner
 *
 */
window.addEventListener("resize", () => {
	getMegaMenuPosition();
	documentHeight();
});


// POPUP ADD TO CARD **********************************************************************************
/*********************************************************************************************
 * Show the popup add to card.
 *
 */

function showAddToCartPopup(data) {

    const popup = document.querySelector('.mm-popup-add-to-card');
    if (popup) {
        // Vérifier si la popup est déjà active
        const isAlreadyActive = popup.classList.contains('active');

        // Si on a des données du produit et que la popup n'est pas déjà active
        if (data && data.image && !isAlreadyActive) {
            // Mettre à jour l'image du popup avec l'image du produit ajouté
            const productImage = popup.querySelector('.mm-popup-product-image');
            if (productImage && data.image) {
                productImage.src = data.image;
                productImage.alt = data.product_title || data.title || 'Produit ajouté au panier';
            }
        }
		if (data.items && data.items.length > 0 && data.items[0].image) {
            const productImage = popup.querySelector('.mm-popup-product-image');
			productImage.src = data.items[0].image;
		}

        // Si la popup n'est pas déjà active, l'activer
        if (!isAlreadyActive) {
            popup.classList.add('active');
            setTimeout(() => {
                popup.classList.remove('active');
            }, 2000);
        }
    }
}

function closeAddToCartPopup() {
    const popup = document.querySelector('.mm-popup-add-to-card');
    if (popup) {
        popup.classList.remove('active');
    }
}

function adjustPopupTopSmoothOnScroll() {
    const popup = document.querySelector('.mm-popup-add-to-card');
    if (!popup) return;

    function updatePosition() {
        const isMobile = window.innerWidth < 768;

        if (isMobile) {
            popup.style.top = 'initial'; // top fixe en dessous de 768px
            return;
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const maxScroll = 70;
        const minTop = 76;
        const maxTop = 104;

        const clampedScroll = Math.min(scrollTop, maxScroll);
        const topValue = maxTop - (clampedScroll / maxScroll) * (maxTop - minTop);

        popup.style.top = `${topValue}px`;
    }

    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);
    document.addEventListener('DOMContentLoaded', updatePosition);
}